import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import {
  SimpleTableHeadRowItem,
  SimpleTableHeadRowItemProps,
} from './simple-table-head-row-item';
import {
  SimpleTableBodyRow,
  SimpleTableBodyRowProps,
} from './simple-table-body-row';

export interface SimpleTableProps {
  headRow: SimpleTableHeadRowItemProps[];
  rows: SimpleTableBodyRowProps[];
  status: LoadingState;
}

export const SimpleTable = types
  .model({
    headRow: types.optional(types.array(SimpleTableHeadRowItem), []),
    rows: types.optional(types.array(SimpleTableBodyRow), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: SimpleTableProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }));
